/* eslint-disable no-undef */
export const initializePendo = (auth) => {
  return pendo.initialize(auth);
};

export const identifyPendo = (params) => {
  return pendo.identify(params);
};

export const isPendoReady = () => {
  return pendo.isReady();
};
